import * as React from "react";
import styled from "styled-components";

import { IComboBoxEmptyStateProps } from "./EmptyState";

const StyledSpanOuter = styled.span`
  align-self: flex-start;
  margin-left: 4px;

  color: #343741;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  padding: 0 8px;
  display: inline-block;
  text-decoration: none;
  border-radius: 3px;
  border: solid 1px #D3DAE6;
  background-color: #fff;
  white-space: nowrap;
  vertical-align: middle;
  cursor: default;
  max-width: 100%;
  text-align: left;
`;
StyledSpanOuter.displayName = "StyledDefaultEmptyStateStyledSpanOuter";

const StyledSpanInner = styled.span`
  min-height: 18px;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: row-reverse;
`;
StyledSpanInner.displayName = "StyledDefaultEmptyStateStyledSpanInner";

const StyledIcon = styled(() =>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
       focusable="false" role="img"
       aria-hidden="true">
    <path
      d="M11.994 4c1.059 0 1.924.818 2 1.856l.006.15v1.988a2.005 2.005 0 01-1.856 2L12 10H3.484l1.91 1.82a.52.52 0 010 .77.616.616 0 01-.829 0l-2.05-1.95a1.551 1.551 0 010-2.31l2.05-1.95a.617.617 0 01.83 0 .52.52 0 010 .77L3.45 9H12c.514-.003.935-.39.993-.888L13 7.994V6.006c0-.516-.388-.941-.888-1L11.994 5H9.5a.5.5 0 01-.09-.992L9.5 4h2.494z"></path>
  </svg>
)`
  width: 16px;
  height: 16px;

  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
  transform: translate(0, 0);

  color: inherit;

  flex: 0 0 auto;
`;
StyledIcon.displayName = "StyledDefaultEmptyStateStyledIcon";

const StyledDefaultEmptyState = styled.div`
  display: flex;
  margin: 0 20px;
  justify-content: space-between;
`;
StyledDefaultEmptyState.displayName = "StyledDefaultEmptyState";

export function DefaultEmptyState({ close, value }: IComboBoxEmptyStateProps): JSX.Element {
  return <StyledDefaultEmptyState>
    <p>Add <strong>{value}</strong> as a custom option</p>
    <StyledSpanOuter>
      <StyledSpanInner>
        <StyledIcon />
      </StyledSpanInner>
    </StyledSpanOuter>
  </StyledDefaultEmptyState>;
};
